export default "__VITE_ASSET__Dhl5uZ7z__"